import * as ApiDTOs from "./ApiDtos";
import Either from "../types/Either";

export enum ApiMode {
    Direct = 'DIRECT', // Native bundle/Mini-App (Token-based)
    WebOrigin = 'WEB_ORIGIN'    // PWA App (Cookie-based)
}

// This is just an example. This should replace ApiAcces
export type ApiAccessType = 
    | { mode: ApiMode.Direct; bearerToken: string }
    | { mode: ApiMode.WebOrigin; headers: {'X-XSRF-TOKEN': string;} }; 


export interface ApiError {
    title: string;
    details: string;
}

export class ApiAccess {
    type: ApiAccessType;
    constructor(type: ApiAccessType) {
        this.type = type;
    }
}

export interface IApiClient {
  //setApiAccess(apiAccess: ApiAccess): void;


  // ────────────────────────────────
  // Public Master Data APIs
  // ────────────────────────────────
  getMasterData(appId: string
  ): Promise<Either<ApiError, ApiDTOs.MasterDataDTO>>;

  getInitialSourceLocations(
    appId: string
  ): Promise<Either<ApiError, ApiDTOs.SourceLocationDTO[]>>;


  getArticle(slug:string) : Promise<Either<ApiError, ApiDTOs.ArticleDTO>>;

  getOperatorPhotos(operatorId:string) : Promise<Either<ApiError, string[]>>;


  // ────────────────────────────────
  // Trip Search APIs
  // ────────────────────────────────
  searchTrips(
    searchCriteria: ApiDTOs.TripSearchCriteria
  ): Promise<Either<ApiError, ApiDTOs.TripResultAggregateDTO>>;

  getTripDetails(
    tripId: string
  ): Promise<Either<ApiError, ApiDTOs.TripDTO>>;

  // ────────────────────────────────
  // Trip Customization APIs
  // ────────────────────────────────
  createTripCustomization(
    createRequest: ApiDTOs.TripCustomizationCreateRequest
  ): Promise<Either<ApiError, ApiDTOs.TripCustomizationDTO>>;

  updateTripCustomization(
    customizationId: string,
    updateRequest: ApiDTOs.TripCustomizationUpdateRequestDTO
  ): Promise<Either<ApiError, ApiDTOs.TripCustomizationDTO>>;

  getTripCustomization(
    customizationId: string
  ): Promise<Either<ApiError, ApiDTOs.TripCustomizationDTO>>;

  // ────────────────────────────────
  // Tentative Booking APIs
  // ────────────────────────────────
  createTentativeBooking(
    createRequest: ApiDTOs.TentativeBookingCreateRequestDTO
  ): Promise<Either<ApiError, ApiDTOs.TentativeBookingDTO>>;

  updateTentativeBooking(
    tentativeBookingId: string,
    updateRequest: ApiDTOs.TentativeBookingUpdateRequestDTO
    ): Promise<Either<ApiError, ApiDTOs.TentativeBookingDTO>>;

    getTentativeBooking(
        tentativeBookingId: string
    ): Promise<Either<ApiError, ApiDTOs.TentativeBookingDTO>>;

  // ────────────────────────────────
  // Payment Flow APIs
  // ────────────────────────────────
  getPaymentOptions(
    billId: string
  ): Promise<Either<ApiError, ApiDTOs.PaymentOptionDTO[]>>;

  verifyPromoCode(
    createRequest: ApiDTOs.PromoCodeVerificationRequestDTO
  ): Promise<Either<ApiError, ApiDTOs.PromoCodeVerifiedResponseDTO>>;

  createPaymentIntent(
    createRequest: ApiDTOs.PaymentIntentCreateRequestDTO
  ): Promise<Either<ApiError, ApiDTOs.PaymentIntentDTO>>;

  createMiniAppPaymentInitiation(
    createRequest: ApiDTOs.PaymentIntentCreateRequestDTO
  ): Promise<Either<ApiError, ApiDTOs.MiniappPaymentIntentDTO>>;



  // ────────────────────────────────
  // Booking Request APIs
  // ────────────────────────────────
  getBookingRequestCreation(
    tentativeBookingId: string
  ): Promise<Either<ApiError, ApiDTOs.BookingRequestDTO>>;

  searchBookingRequests(
    appUserId: string | undefined,
    pageNo: number,
    pageSize: number
  ): Promise<Either<ApiError, ApiDTOs.BookingRequestResultsAggregateDTO>>;

  getBookingRequestDetails(
    bookingRequestId: string
  ): Promise<Either<ApiError, ApiDTOs.BookingRequestDTO>>;



  // ────────────────────────────────
  // Booking APIs
  // ────────────────────────────────
  checkBooking(
    tentativeBookingId: string
  ): Promise<Either<ApiError, ApiDTOs.BookingDTO>>;

  searchBookings(
    pageNo: number,
    pageSize: number
  ): Promise<Either<ApiError, ApiDTOs.BookingResultSet>>;

  getBookingDetails(
    bookingId: string
  ): Promise<Either<ApiError, ApiDTOs.BookingDTO>>;
}

export interface PaymentApiError {
    title: string;
    detail: string;
}
